import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AnnotationElement,
  DataElement,
  ProcessRunStatusEnum,
  SearchRunStatusEnum,
} from '../shared/models/common';
import { NgRedux } from '@redux/redux-compatibility.service';
import { AppState, actionsList } from '../shared/redux/store';
import { RevClaimBlockResult, RevService } from '../shared/services/rev.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../shared/services/shared.service';
import {
  RevDoc,
  RevRulesSearchParams,
  RevRule,
  RevDocStatusEnum,
  RevDocsSearchParams,
  RevStatus,
  DirectLinkDoc,
} from '../shared/models/rev.model';
import { Location } from '@angular/common';
import { DocViewerComponent } from '../shared/components/doc-viewer/doc-viewer.component';
import { keyCodes } from '../shared/models/key-codes.model';
import Chart from 'chart.js';
import { Unsubscribe } from 'redux';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../shared/services/auth.service';
import { RevDocRulesListComponent } from './rev-doc-rules-list/rev-doc-rules-list.component';
import { TreeNode } from 'primeng/api';
import { CatService } from '../shared/services/cat.service';
import { IntegrationService } from '../shared/services/integration.service';
import { BoundingBox, Card, CatPhraseSubType } from '../shared/models/cat.model';
import { PdfViewerComponent } from '../shared/components/pdf-viewer/pdf-viewer.component';
import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { TabIdList } from '../shared/models/tab.model';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { CommonService } from '@shared/services/common.service';
import { getObjectPropValue } from '@shared/utils';
import { DocumentPositionSyncService } from '@shared/services/document-position-sync.service';
import { ReevalJobService } from '@shared/services/reeval-job.service';
import { ProcessStatusPollingService } from '@shared/services/process-status-polling.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-rev-doc',
    templateUrl: './rev-doc.component.html',
    styleUrls: ['./rev-doc.component.scss'],
    standalone: false
})
export class RevDocComponent implements OnInit, OnDestroy {
  @ViewChild('docViewer') docViewer: PdfViewerComponent;
  claimBlockSaving: boolean = false;
  @ViewChild('revRulesList') revRulesList: RevDocRulesListComponent;
  @ViewChild('page', { static: false }) public pageDiv: ElementRef;

  loading: boolean;
  filterPhrase: string;
  filterRuleType: DataElement;
  filterStatus: DataElement;
  filterContentType: DataElement;
  filterMatchType: DataElement;
  selectedTypeNodes: TreeNode[];
  filterSubTypes: string[];
  canvasStatus: any;
  canvasBarStatus: any;
  ctxStatus: any;
  ctxBarStatus: any;
  un: Unsubscribe;
  unPageChange: Subscription;
  initAnnotationsloadedPageNum: number;
  docFrameLoadedPageNum: number;
  rulesListLoadedPageNum: number;
  toggleAllSw: boolean;
  downloadingFile: boolean;
  processStatusTimer: NodeJS.Timeout;
  getProcessStatusIntervalSeconds: number = 3;
  panelResizing: boolean;
  showMoreDocDetailsSw: boolean;
  showBarStatusChart: boolean;
  docCardsOpenSw: boolean;
  getCardsSub: Subscription;
  searchStatusTimer: any;
  searchStatusIntervalSec: number = 2;
  sub: Subscription;
  cardsLoading: boolean;
  toggleImageAnnotationsSw: boolean;
  downloadingZip: boolean;
  sub2: Subscription;
  subCard: Unsubscribe;
  tabIdList: TabIdList;
  docFrameLoaded: boolean = false;
  docSpellcheckWhitelistingOpenSw: boolean;
  activeFilters: boolean = false;
  loadingMoreItems = false;
  pageToolOpenSw: boolean;
  destroy$ = new Subject();
  doughnutChart: Chart;
  barChart: Chart;
  toggleableFilters: {id: string, key: string, checked: boolean}[] = [];
  getProcStatusFailedCnt: number = 0;
  displayProcessStatus: boolean;
  docProcessingTimer: NodeJS.Timeout;
  docInitInProgress: boolean = false;
  handleProcessingDocTimer: NodeJS.Timeout;
  private lastScrollFocusedRuleId?: number;
  private scrollSyncFrameId: number | null = null;
  
  toggleButtonsEnabledConfig: {
      
    evaluate_critical: boolean;
    evaluate_other: boolean;
    matched: boolean;
    red_flag: boolean
  } = {
    evaluate_critical: true,
    evaluate_other: true,
    matched: true,
    red_flag: true
  }
  propagate_doc_prefs = true;

  get dlRevDoc(): DirectLinkDoc {
    return this.ngRedux.getState().dlRevDoc;
  }

  get doc(): RevDoc {
    return this.ngRedux.getState().curRevDoc;
  }

  get ruleTypeList(): DataElement[] {
    return this.ngRedux.getState().revRuleTypeList;
  }

  get ruleStatusList(): DataElement[] {
    return this.ngRedux.getState().revRuleStatusList;
  }

  get contentTypeList(): DataElement[] {
    return this.ngRedux.getState().contentTypeList;
  }

  get matchTypeList(): DataElement[] {
    return this.ngRedux.getState().revRuleSimilarityEventList;
  }

  get docCards(): Card[] {
    return this.ngRedux.getState().revDocCards;
  }

  get curPage(): number {
    return (this.dlRevDoc && !this.dlRevDoc.dlDocHandled)
      ? this.dlRevDoc.page
      : this.ngRedux.getState().curRevDocPageNum;
  }

  get currLoadedRuleNum() {
    return this.ngRedux.getState().currLoadedRuleNum;
  }

  set currLoadedRuleNum(currLoadedRuleNum) {
    
    this.ngRedux.getState().currLoadedRuleNum = currLoadedRuleNum;
  }

  get displayClearFilter(): boolean {
    return (
      this.filterPhrase != null ||
      this.filterRuleType != null ||
      this.filterStatus != null ||
      this.filterContentType != null ||
      this.filterMatchType != null ||
      this.filterSubTypes != null
    );
  }

  get selectedRules(): RevRule[] {
    let selectedRules = [];
    let allRules = this.ngRedux.getState().revDocRules
    allRules?.forEach((rule) => {
      if (rule.checkedSw) {
        selectedRules.push(rule);
      }
      let selectedChildRules = rule.contentChildren?.filter((childRule) => childRule.checkedSw);
      selectedRules = selectedRules.concat(selectedChildRules);
      
      selectedChildRules = rule.imageChildren?.filter((childRule) => childRule.checkedSw);
      selectedRules = selectedRules.concat(selectedChildRules);

      rule.children && Object.keys(rule.children).forEach((key) => {

        selectedChildRules = rule.children[key]?.filter(childRule => childRule.checkedSw);
        selectedRules = selectedRules.concat(selectedChildRules);
      })
    })
    return selectedRules;

  }

  get displayedRules(): RevRule[] {
    return this.ngRedux.getState().revDocRules;
  }

  get editable(): boolean {
    return this.doc.statusCode == RevDocStatusEnum.UNDERWAY && !this.doc.isProcessRunning;
  }

  get allowFinalize(): boolean {
    return (
      this.ngRedux.getState().curRevDoc.statusCode ==
        RevDocStatusEnum.UNDERWAY ||
      this.ngRedux.getState().curRevDoc.statusCode == RevDocStatusEnum.COMPLETED
    );
  }

  get allowComplete(): boolean {
    return (
      this.ngRedux.getState().curRevDoc.statusCode == RevDocStatusEnum.UNDERWAY
    );
  }

  get allowReopen(): boolean {
    return (
      this.ngRedux.getState().curRevDoc.statusCode != RevDocStatusEnum.UNDERWAY
    );
  }

  get allowInactivate(): boolean {
    return (
      this.ngRedux.getState().curRevDoc.statusCode != RevDocStatusEnum.INACTIVE
    );
  }

  get catPhraseTypes(): TreeNode[] {
    if (!this.ngRedux.getState().catPhraseTypeModel) return [];
    return this.ngRedux.getState().catPhraseTypeModel.treeTypes;
  }

  get pageLoading(): boolean {
    return this.ngRedux.getState().docPageLoading;
  }

  get totalRules(): number {
    return this.ngRedux.getState().totalRules;
  }

  get positionSyncEnabled(): boolean {
    return this.documentPositionSyncService.isEnabled(this.ngRedux.getState().uiConfig);
  }
  get sortImagesInPositionSync(): boolean {
    return getObjectPropValue(
      this.ngRedux.getState().uiConfig,
      'tiles_config.images_sorted_by_y'
    ) === true;
  }
  get docPageLoading() {
    
    return this.ngRedux.getState().docPageLoading;
  }
  get addToStore(): boolean {
    return this.ngRedux.getState().addToStore;
  }
  
  get revRuleIgnoredStatusCodes(): {id: string, key: string}[] {

    return this.ngRedux.getState().revRuleIgnoredStatusCodes;
  }
  set addToStore(value: boolean) {
    this.ngRedux.getState().addToStore = value;
  }
  hasResults(): boolean {  
    
      return this.currLoadedRuleNum < this.totalRules;
  }

  get displayFilterOptions(): string[] {
    let displayFilterOptions = ['notPassedSevCnt'];
    if (this.doc.newContentCnt > 0) {
      displayFilterOptions.push('newContentCnt');
    };
    displayFilterOptions = displayFilterOptions.concat([
      'failedCnt',
      'notPassedVarCnt',
      'passedCnt'
    ]);
    if (this.doc.newContentCnt > 0) {
      displayFilterOptions.push('newContentCnt');
    };
 
    if (this.doc.dismissedCnt > 0) {
      displayFilterOptions.push('dismissedCnt');
    };
    displayFilterOptions = displayFilterOptions.concat(
      [
        'stetCnt',
        'markedCnt',        
        'newClaimCnt',
        'claimVariantCnt'        
      ]
    );
    return displayFilterOptions;
  }

  initializeToggleableFiltersEnvironmentConfigOnly() {
        this.toggleableFilters = [
          {id: RevStatus.PASSED, key: 'passedCnt', checked: this.toggleButtonsEnabledConfig.matched},
          {id: RevStatus.NOT_PASSED_VAR, key: 'notPassedVarCnt', checked: this.toggleButtonsEnabledConfig.evaluate_other },
          {id: RevStatus.NOT_PASSED_SEV, key: 'notPassedSevCnt', checked: this.toggleButtonsEnabledConfig.red_flag },
          {id: RevStatus.NOT_PASSED, key:'failedCnt', checked: this.toggleButtonsEnabledConfig.evaluate_critical }

        ]
        const ignoredFilters = this.ngRedux.getState().revRuleIgnoredStatusCodes;


        
          for (let filter of this.toggleableFilters) {

            if (!filter.checked) {
              ignoredFilters?.push({
                id: filter.id,
                key: filter.key
              })
            }
          }
    
  }

  initializeToggleableFilters() {


    const ignoredFilters = this.ngRedux.getState().revRuleIgnoredStatusCodes;
    if (!ignoredFilters || ignoredFilters.length == 0) {
      this.initializeToggleableFiltersEnvironmentConfigOnly()
    } else {
        this.toggleableFilters = [
          {id: RevStatus.PASSED, key: 'passedCnt', checked: true},
          {id: RevStatus.NOT_PASSED_VAR, key: 'notPassedVarCnt', checked: true },
          {id: RevStatus.NOT_PASSED_SEV, key: 'notPassedSevCnt', checked: true },
          {id: RevStatus.NOT_PASSED, key:'failedCnt', checked: true }

        ]


      for (let i = 0; i < ignoredFilters.length; i++) {
        const foundedFilter = this.toggleableFilters.find(filter => filter.key == ignoredFilters[i].key);

        if (foundedFilter) {
          foundedFilter.checked = false;
        }
      }


      for (let filter of this.toggleableFilters) {

        if (!filter.checked) {
          ignoredFilters?.push({
            id: filter.id,
            key: filter.key
          })
        }
      }
    }

  }

  get filteredRuleStatusList(): DataElement[] {
    const ORDER = [
      'NOT_PASSED_SEV',
      'NOT_PASSED_NEW_CONTENT',
      'NOT_PASSED',
      'NOT_PASSED_VAR',
      'PASSED',
      'STET',
      'MARKED_FOR_CHANGES',
      'NEW_CLAIM',
      'CLAIM_VARIANT'
    ];

    return this.ruleStatusList.filter(s => {
      if (s.id == 'NOT_PASSED_NEW_CONTENT') {
        return this.doc.newContentCnt > 0;
      }
      if (s.id == 'DISMISSED') {
        return this.doc.dismissedCnt > 0;
      }
      if (this.ngRedux.getState().revRuleIgnoredStatusCodes.length > 0) {
        
        return this.ngRedux.getState().revRuleIgnoredStatusCodes.find(ignoredStatusCode => ignoredStatusCode.id == s.id) == null;
      }
      return true;
    })
    .sort((a, b) => {
      const indexA = ORDER.indexOf(a.id);
      const indexB = ORDER.indexOf(b.id);
      return indexA - indexB;
    });

  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private revService: RevService,
    private router: Router,
    private sharedService: SharedService,
    private location: Location,
    private authService: AuthService,
    private translateService: TranslateService,
    private catService: CatService,
    private integrationService: IntegrationService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private reevalJobService: ReevalJobService,
    private processStatusPollingService: ProcessStatusPollingService,
    private documentPositionSyncService: DocumentPositionSyncService
  ) {
    this.tabIdList = this.ngRedux.getState().ui_tabIdList;

    this.un = this.ngRedux.subscribe(() => {
      const appState = this.ngRedux.getState();
      switch (appState._currentAction) {
        case actionsList.UPD_REV_DOC_STATS:
          this.drawStatusChart();

          break;
        case actionsList.ADD_REV_DOC_RULES: {
          this.onPdfScroll();
          break;
        }
        case actionsList.GET_REV_DOC_RULES: {
          const loadedPageNum = this.curPage;
          const pageChanged = this.rulesListLoadedPageNum !== loadedPageNum;
          this.rulesListLoadedPageNum = loadedPageNum;
          this.lastScrollFocusedRuleId = undefined;

          if (pageChanged && this.positionSyncEnabled) {
            requestAnimationFrame(() => {
              this.revRulesList?.scrollToFirstRuleOnPage(loadedPageNum);
            });
          }
/*           if (
            this.initAnnotationsloadedPageNum !== this.curPage &&
            this.docFrameLoadedPageNum == this.curPage
          ) {
            this.addAllAnnotationsToDoc();
            setTimeout(() => {
              this.toggleFailedAnnotations();
            }, 500);
          } */
          break;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.scrollSyncFrameId != null) {
      cancelAnimationFrame(this.scrollSyncFrameId);
    }
    this.reevalJobService.setDocViewOpen('REV', false);

    this.ngRedux.dispatch({
        type: actionsList.GET_IMAGE_CATEGORIES_FOR_DOC,
        data: []
    });
    this.ngRedux.dispatch({
      type: actionsList.SET_DL_REV_DOC,
      data: null,
    });
    // we can't trigger search with dispatching action since rev-doc-rules-list component isnt created at this moment
    this.revService.shouldSearch = false;
    this.ngRedux.getState().curRevDocPageNum = 1;
    if (this.docProcessingTimer) {
      clearInterval(this.docProcessingTimer);
    }

    if (this.un) this.un();
    this.sub2?.unsubscribe();
    if (this.subCard) this.subCard();
    if (this.processStatusTimer) {
      clearInterval(this.processStatusTimer);
    }
    if (this.handleProcessingDocTimer) {
      clearInterval(this.handleProcessingDocTimer);
    }
    this.resetFilterParams();
    this.destroy$.next();
    this.destroy$.complete();

    this.ngRedux.getState().revRuleIgnoredStatusCodes = [];
    this.currLoadedRuleNum = 0;
  }

  ngOnInit(): void {
    this.reevalJobService.setDocViewOpen('REV', true);
    this.reevalJobService.resumePersistedJobs();

    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      //get rev doc with id

      let docId = parseInt(id, 10);
      let envId = this.ngRedux.getState().curEnv.id;
      this.docInitInProgress = true;
      this.revService.getSingleRevDoc(docId, envId).subscribe((revDoc: RevDoc) => {
        let viewDoc: RevDoc = null;
        const versionId = this.activatedRoute.snapshot.queryParamMap.get('versionId');
        if (versionId) {
          const versionIdValue = Number.parseInt(versionId, 10);
          revDoc = revDoc.docVersions.find((d) => d.versionId == versionIdValue);
        }
        if (revDoc.docVersions.length > 0) {
            viewDoc = revDoc.docVersions.find((d) => d.versionId == revDoc.lastVersionId); //doc.docVersions[doc.docVersions.length - 1];
            viewDoc.newCatVersionSw = revDoc.newCatVersionSw;
        } else {
            viewDoc = revDoc;
        }
        
        this.ngRedux.dispatch({
          type: actionsList.SELECT_REV_DOC,
          data: viewDoc,
        });
        this.docInitInProgress = false;
        this.docInitialization();

      });
    } else {
        // navigate to rev-doc-list
        this.ngRedux.dispatch({
          type: actionsList.UI__ROUTE_NAVIGATION,
          data: this.sharedService.routeEnum.URL_REV_DOC_LIST,
        });
        this.router.navigate([this.sharedService.routeEnum.URL_REV_DOC_LIST]);

      }

  }
  getImageCategories() {
    this.commonService.getImageCategoriesForDocument(this.doc.docId, true).subscribe();
  }
  docInitialization() {

    //poll doc processing status until component is destroyed or doc is not processing anymore
    // start polling only if document isn't processed yet
    if (this.doc?.isProcessRunning) {
      this.docProcessingTimer = setInterval(() => {
        if (!this.doc?.isProcessRunning) {
          //clear cache
          // reload page to get updated doc status
          this.ngRedux.dispatch({
            type: actionsList.INVALIDATE_PDF_CACHE
          });
          this.ngRedux.dispatch({
            type: actionsList.RELOAD_CAT_DOC_PAGE_REQ
          });
          clearInterval(this.docProcessingTimer);
        }
      }, 1000);
    }

    if (this.dlRevDoc) {
      this.dlRevDoc.dlDocHandled = true;
    }

    this.subCard = this.ngRedux.subscribe(() => {
      const appState = this.ngRedux.getState();
      switch (appState._currentAction) {
        case actionsList.GET_REV_DOC_CARDS_START:
          this.ngRedux.getState().revDocCards = [];
          this.getRevCards();
          break;
      }
    });
    this.getRevCards();
    this.getDocObjects();

    const uiConfig = this.ngRedux.getState().uiConfig;
    this.propagate_doc_prefs = getObjectPropValue(uiConfig, 'dashboard_config.propagate_doc_prefs') ?? true;
    const toggleButtonsEnabledConfigValue = getObjectPropValue(uiConfig, 'dashboard_config.toggle_buttons_enabled');
    if (toggleButtonsEnabledConfigValue != null) {
      this.toggleButtonsEnabledConfig = toggleButtonsEnabledConfigValue;
    }
    if (this.propagate_doc_prefs) {
      this.initializeToggleableFiltersUsingDocPrefs();
    } else {
      this.initializeToggleableFiltersEnvironmentConfigOnly();
      this.revService.shouldSearch = true;
    }

    

   
    this.addToStore = false;
    this.revService.changePdfPage$.pipe(takeUntil(this.destroy$)).subscribe((page:number) => {
      
      this.ngRedux.getState().curRevDocPageNum = page;
      this.docViewer.goToNewPageOnDetailsOpen(page, false);
    })
    this.revService.showAnnotationForRule$.pipe(takeUntil(this.destroy$)).subscribe((rule: RevRule) => {

        
            rule.viewSw = true;
            this.onToggleRuleView(rule, false);
    })
    this.revService.focusAnnotationForRule$.pipe(takeUntil(this.destroy$)).subscribe((rule: RevRule) => {
      requestAnimationFrame(() => this.docViewer?.focusAnnotation(rule));
    });
    this.revService.hideAnnotationForRule$.pipe(takeUntil(this.destroy$)).subscribe((rule: RevRule) => {
      
      let hideAnnotation = this.docViewer.displayAnnotations;
      if (rule.isImage) {
        hideAnnotation = this.docViewer.displayImageAnnotations;
      }
      if (!hideAnnotation) {
        
            rule.viewSw = false;
            this.onToggleRuleView(rule, false);      
      }
    })
    if (this.doc.isProcessRunning) {
      
      this.handleProcessingDoc();
    }
    this.getImageCategories();
  }
  ngAfterViewInit(): void {
    let main = document.getElementById('main');
    console.log(main);
    main.addEventListener(
      'scroll',
      (event) => {
        this.showBarStatusChart = this.showBarStatusChart && main.scrollTop > 220 || !this.showBarStatusChart && main.scrollTop > 240;
      },
      { passive: true }
    );
  }

  getDocObjects() {
    this.catService.getDocObjects(this.doc.docId, 'REV').subscribe(
      (data) => {
        setTimeout(() => {
          // this will pick up presigned URLs for any of remaining rev doc cards bounding boxes' thumbnails
          this.catService.resolveAnyRemainingPresignedUrl();
        }, 2000);        
      },
      (err) => (console.log('An error occurred geting REV doc objects', this.doc.docId, err))
    );
  }
  clearCanvas() {
    const canvas = document.getElementById('chart-status-cnv') as HTMLCanvasElement;
    let ctx = null;
    if (canvas) {
        
      ctx = canvas.getContext('2d');

    }
    if (ctx) {

      ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset transform if any
      ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the full canvas
    }

  }

  initializeToggleableFiltersUsingDocPrefs() {
    this.revService.getRevIgnoredStatus(this.doc.docId).subscribe((revIgnoredRules: string | null) => {

      let mappedRevIgnoredRules: {id: string; key: string}[] = this.revService.mapRevIgnoredRules(revIgnoredRules);
      
      this.ngRedux.dispatch({
        type: actionsList.GET_REV_IGNORED_STATUS_CODES,
        data: mappedRevIgnoredRules
      })
      this.initializeToggleableFilters();
      this.ngRedux.dispatch({
              type: actionsList.SELECT_REV_DOC_PAGE_NUM,
              data: this.dlRevDoc ? this.dlRevDoc.page : 1,
        })

    }, (error) => {

      console.log(error);
      // can't retrieve user preference
      this.initializeToggleableFiltersEnvironmentConfigOnly();
      //this.revService.shouldSearch = true;
      this.ngRedux.dispatch({
              type: actionsList.SELECT_REV_DOC_PAGE_NUM,
              data: this.dlRevDoc ? this.dlRevDoc.page : 1,
        }) 
    } )
  }
  getStatusDataset() {
    

    let doneCnt = Math.round(this.doc.progressPct * this.doc.totCnt);

    let newContentCnt = this.doc.newContentCnt;
    let notPassedCnt = this.doc.failedCnt;
    let notPassedVarCnt = this.doc.notPassedVarCnt;

    let notPassedSevCnt = this.doc.notPassedSevCnt;
    let failedCnt = this.doc.failedCnt;

    let data = [doneCnt, notPassedVarCnt, notPassedCnt, notPassedSevCnt];
    let labels = [        
        this.translateService.instant('translate.general.done'),
        this.translateService.instant('translate.general.notPassedVarCnt'),
        this.translateService.instant('translate.generate.evaluateCritical'),
        this.translateService.instant('translate.general.notPassedSevCnt')
      ];
    let backgroundColor = ['#62bd60', '#f9c74f', '#f35f3e', '#a2231d'];
    let hoverBackgroundColor = ['#62bd60', '#f9c74f', '#f35f3e', '#a2231d']; 

    return {
      data: data,
      backgroundColor: backgroundColor,
      hoverBackgroundColor: hoverBackgroundColor,
      labels: labels
    };
  }

  drawStatusChart() {
    
    //this.clearCanvas();
    if (this.doughnutChart != null) {
      
      this.doughnutChart.destroy();
    }
    if (this.barChart != null) {
      
      this.barChart.destroy();
    }
    this.drawBarStatusChart();

    this.canvasStatus = document.getElementById('chart-status-cnv');
    if (!this.canvasStatus) return;
    this.ctxStatus = this.canvasStatus.getContext('2d');
    let dataset = this.getStatusDataset();
     this.doughnutChart = new Chart(this.ctxStatus, {
      type: 'doughnut',
      data: {
        datasets: [dataset],
        labels: dataset.labels,
      },
      options: {
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems, data) => {
              return (
                data.labels[tooltipItems.index] +
                ' ' +
                data.datasets[0].data[tooltipItems.index]
              );
            },
          },
        },
        cutoutPercentage: 70,
        legend: {
          display: false,
        },
        layout: {
          padding: {
            right: 0,
            left: 0,
          },
        },
        elements: {
          center: {
            text: Math.round(this.doc.progressPct * 100) + '%',
            color: '#0978A2',
            sidePadding: 40,
          },
        },
      },
    });
  }

  getBarStatusDataset() {
    let doneCnt = Math.round(this.doc.progressPct * this.doc.totCnt);
    let notPassedCnt = this.doc.failedCnt;
    let notPassedVarCnt = this.doc.notPassedVarCnt;

    let notPassedSevCnt = this.doc.notPassedSevCnt;

    return [
      {
        data: [doneCnt],
        backgroundColor: ['#62bd60'],
        hoverBackgroundColor: ['#62bd60'],
        label: this.translateService.instant('translate.general.done'),
      },
      {
        data: [notPassedVarCnt],
        backgroundColor: ['#f9c74f'],
        hoverBackgroundColor: ['#f9c74f'],
        label: this.translateService.instant('translate.general.notPassedVarCnt'),
      },

      {
        data: [notPassedCnt],
        backgroundColor: ['#f35f3e'],
        hoverBackgroundColor: ['#f35f3e'],
        label: this.translateService.instant('translate.generate.evaluateCritical'),
      },
      {
        data: [notPassedSevCnt],
        backgroundColor: ['#a2231d'],
        hoverBackgroundColor: ['#a2231d'],
        label: this.translateService.instant('translate.general.notPassedSevCnt'),
      }
    ];
  }

  drawBarStatusChart() {
    this.canvasBarStatus = document.getElementById('chart-bar-status-cnv');
    if (!this.canvasBarStatus) return;
    this.ctxBarStatus = this.canvasBarStatus.getContext('2d');
    let datasets = this.getBarStatusDataset();
    this.barChart = new Chart(this.ctxBarStatus, {
      type: 'horizontalBar',
      data: {
        datasets: datasets,
        labels: datasets.map((d) => d.label),
      },
      options: {
        animation: {
          duration: 0,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              stacked: true,
              scaleLabel: {
                display: false,
              },
              ticks: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              barThickness: 20,
              gridLines: {
                display: false,
              },
              stacked: true,
              scaleLabel: {
                display: false,
              },
              ticks: {
                display: false,
              },
            },
          ],
        },
        tooltips: {
          enabled: true,
          mode: 'dataset',
          callbacks: {
            title: (tooltipItems, data) => {
              return '';
            },
            label: (tooltipItems, data) => {
              return (
                data.datasets[tooltipItems.datasetIndex].label +
                ': ' +
                tooltipItems.value
              );
            },
          },
        },
        legend: {
          display: false,
        },
      },
    });
  }

  roundNumber(value: number) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  goBack() {
    this.ngRedux.dispatch({
      type: actionsList.SET_DL_REV_DOC,
      data: null,
    });

    this.ngRedux.dispatch({
      type: actionsList.SELECT_REV_DOC,
      data: null,
    });
    this.router.navigate([this.sharedService.routeEnum.URL_REV_DOC_LIST]);
  }

  onFilterKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.filterRules();
    }
  }

  onPdfScroll(): void {
    if (!this.positionSyncEnabled) {
      return;
    }
    if (this.scrollSyncFrameId != null) {
      return;
    }

    this.scrollSyncFrameId = requestAnimationFrame(() => {
      this.scrollSyncFrameId = null;
      if (!this.positionSyncEnabled || this.docViewer?.programmaticScrollActive) {
        return;
      }
      const viewer = this.docViewer?.pdfViewer?.PDFViewerApplication?.pdfViewer;
      const scrollContainer = viewer?.container as HTMLElement | undefined;
      if (!viewer || !scrollContainer) {
        return;
      }

      const syncRules = this.sortImagesInPositionSync
        ? this.displayedRules
        : this.displayedRules.filter(r => !r.isImage);
      const { pageNum: currentPage, element: closestRule } =
        this.documentPositionSyncService.findClosestElement(viewer, syncRules);
      if (!currentPage) {
        return;
      }

      if (closestRule && closestRule.revRuleId !== this.lastScrollFocusedRuleId &&
          this.revRulesList?.scrollToRule(closestRule)) {
        this.lastScrollFocusedRuleId = closestRule.revRuleId;
      }

      // Check if more rules should be loaded when filters are active
      if (
        this.activeFilters &&
        this.positionSyncEnabled &&
        !this.loadingMoreItems &&
        this.hasResults()
      ) {
        const hasHigherPageRules = syncRules.some(r => r.pageNum > currentPage);
        if (!hasHigherPageRules) {
          this.loadMoreItems();
        }
      }
    });
  }

  onFieldValueChanged(e: any) {
    (e.originalEvent as MouseEvent).stopPropagation();
    this.filterRules();
  }

  resetFilterParams() {
    this.activeFilters = false;
    this.filterPhrase = null;
    this.filterRuleType = null;
    this.filterStatus = null;
    this.filterContentType = null;
    this.filterMatchType = null;
    this.filterSubTypes = null;
    this.selectedTypeNodes = null;
    // clear filter annotations
    if (this.docViewer) {
      
      this.docViewer.clearAnnotations();
    }

    this.ngRedux.getState().revRulesSearchParams = this.getSearchParams();
  }

  clearFilter() {
    this.resetFilterParams();

    this.ngRedux.dispatch({
      type: actionsList.SELECT_REV_DOC_PAGE_NUM,
      data: this.curPage,
    });
  }

  getSearchParams(): RevRulesSearchParams {
    let params = new RevRulesSearchParams();
    params.phrase = this.filterPhrase;
    params.ruleType = this.filterRuleType;
    params.ruleStatus = this.filterStatus;
    params.contentType = this.filterContentType;
    params.matchType = this.filterMatchType;
    params.subTypeList = this.filterSubTypes;
    return params;
  }

  filterRules(addRules: boolean = false) {
    this.activeFilters = true;

    if (!addRules) {
      this.currLoadedRuleNum = 0;
      this.ngRedux.getState().totalRules = 0;
    }
    // clear annotations when start filtering
    this.docViewer.clearAnnotations();


    let searchParams = this.getSearchParams();
    searchParams.currLoadedRuleNum = this.currLoadedRuleNum;
    //this.currLoadedRuleNum += 10;

    this.ngRedux.getState().addToStore = addRules;

    this.ngRedux.dispatch({
      type: actionsList.FILTER_REV_RULES,
      data: searchParams
    });
  }

  loadMoreItems() {

    this.loadingMoreItems = true;
    this.filterRules(true);

  }
  loadedMoreItems() {

    this.loadingMoreItems = false;

  }

  finalizeDoc() {
    this.finalizeDocStatus(RevDocStatusEnum.FINAL);
  }

  completeDoc() {
    this.loading = true;
    this.integrationService.completeDoc(this.doc.catVersionId, this.doc.docId).subscribe(
      (data) => {
        this.revService.processUpdRevDocResponse(data);
        this.drawStatusChart();
        this.loading = false;
      },
      (err) => (this.loading = false)
    );
  }

  reopenDoc() {
    this.loading = true;
    this.integrationService.reopenPrecheckDocument(this.doc.catVersionId, this.doc.docId).subscribe(
      (data) => {
        this.revService.processUpdRevDocResponse(data);
        this.drawStatusChart();
        this.loading = false;
      },
      (err) => (this.loading = false)
    );
  }

  inactivateDoc() {
    this.updateDocStatus(RevDocStatusEnum.INACTIVE);
  }

  updateDocStatus(statusCode: string) {
    this.loading = true;
    this.revService.updRevDoc(this.doc, statusCode).subscribe(
      (data) => {
        this.drawStatusChart();
        this.loading = false;
      },
      (err) => (this.loading = false)
    );
  }

  finalizeDocStatus(statusCode: string) {
    this.loading = true;
    this.integrationService.finalizePrecheck(this.doc.docId, statusCode).subscribe(
      (data) => {
        if (data?.revProcedureResult) {
          this.revService.processUpdRevDocResponse(data.revProcedureResult);
        }
        this.drawStatusChart();
        this.loading = false;
      },
      (err) => (this.loading = false)
    );
  }

  onPageChanged(pageNum: number) {
    this.lastScrollFocusedRuleId = undefined;
    if (!this.activeFilters) {
      this.resetFilterParams();
      this.ngRedux.dispatch({
        type: actionsList.SELECT_REV_DOC_PAGE_NUM,
        data: pageNum,
      });
    }
    this.toggleAllSw = false;
    //page is changed on scrolling and filters are active
    if (this.curPage != pageNum) {
      this.ngRedux.dispatch({
        type: actionsList.SELECT_REV_DOC_PAGE_FROM_SEARCH,
        data: pageNum
      })
    }
  }

  ignoreSelected() {
    this.updateStatusSelected(RevStatus.STET);
  }

  markSelected() {
    this.updateStatusSelected(RevStatus.MARKED_FOR_CHANGES);
  }

  updateStatusSelected(status: RevStatus) {
    this.loading = true;
    this.revService
      .updRevRule(this.ngRedux.getState().curRevDoc, this.selectedRules, status)
      .subscribe(
        (data) => {
          this.selectedRules.forEach((r) => {
            let updRule = data.find((d) => d.revRuleId == r.revRuleId);
            r.revStatusCode = updRule.revStatusCode;
            r.revStatusDescr = updRule.revStatusDescr;
            r.ruleUserStatus = updRule.ruleUserStatus;
            this.onToggleRuleView(r);
          });

          this.selectedRules.forEach((r) => {
            r.checkedSw = false;
          });

          this.loading = false;
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  checkIsFiltersActive() {
    return (this.filterRuleType != undefined || this.filterPhrase != undefined || this.filterStatus != undefined || this.filterContentType != undefined || this.filterMatchType != undefined || this.filterSubTypes != undefined); 
  }

  onToggleRuleViewSwitchDisabled(rule: RevRule) {
    let isFilterActive = this.checkIsFiltersActive();

    this.onToggleRuleView(rule, !isFilterActive);
    

  }

  onToggleRuleView(rule: RevRule, changePageSw: boolean = true) {
    let toggleElements = () => {
      this.hideRuleAnnotation(rule);
      if (rule.viewSw) {
        this.showRuleAnnotation(rule);
      } 
    };

    if (rule.pageNum != this.curPage && changePageSw) {
      this.ngRedux.dispatch({
        type: actionsList.SELECT_REV_DOC_PAGE_FROM_SEARCH,
        data: rule.pageNum,
      });
      this.docViewer.goToPage(rule.pageNum);
    } else {
      toggleElements();
    }
  }

  hideRuleAnnotation(rule: RevRule) {
    rule.annId = rule.revRuleId;
    this.docViewer.hideAnnotation(rule, false);
  }

  showRuleAnnotation(rule: RevRule, visible: boolean = true) {
    if (rule.pageNum != this.docViewer.displayedPage) return;

    switch (rule.revStatusCode) {
      case RevStatus.PASSED:
        rule.annColor = '#30bb30';
        break;
      case RevStatus.NOT_PASSED:
        rule.annColor = '#f35f3e';
        break;
      case RevStatus.NOT_PASSED_VAR:
        rule.annColor = '#dbab23';
        break;
      case RevStatus.NOT_PASSED_SEV:
        rule.annColor = '#a2231d';
        break;
      case RevStatus.NEW_CONTENT:
        rule.annColor = '#dbab23';
        break;
      case RevStatus.STET:
        rule.annColor = '#30bb30';
        break;
      case RevStatus.DISMISSED:
        rule.annColor = '#d86c06';
        break;
      case RevStatus.MARKED_FOR_CHANGES:
        rule.annColor = '#ff2229';
        break;
      case RevStatus.NEW_CLAIM:
        rule.annColor = '#62bd60'
        break;
      case RevStatus.CLAIM_VARIANT:
        rule.annColor = '#62bd60';
        break;
      default:
        rule.annColor = '#0978A2';
        break;
    }
    rule.annId = rule.revRuleId;
    this.docViewer.showAnnotation(rule, visible);
  }

  onToggleAnnotations(viewSw: boolean) {

    let phrases = this.displayedRules.filter(rule => !rule.isImage);
    phrases.forEach((r) => {
      if (r.pageNum == this.ngRedux.getState().curRevDocPageNum) {
        r.viewSw = viewSw;
        this.onToggleRuleView(r);
        this.toggleChildrenAnnotations(r, viewSw);
      }
    });
  }

  toggleChildrenAnnotations(rule: RevRule, viewSw: boolean) {
    
    let contentChildren: RevRule[] = rule.contentChildren;
    
    for(let i=0; i<contentChildren.length; i++) {
      
      let child = contentChildren[i];
      child.viewSw = viewSw;

      this.onToggleRuleView(child);
    }
    //this.toggleChildrenImageAnnotation(rule, viewSw);

    let childrenKeys: string[] = Object.keys(rule.children);
    childrenKeys?.forEach(key => {

      let currChildArr: RevRule[] = rule.children[key];
      for (let i=0; i<currChildArr.length; i++) {

        let child = currChildArr[i];
        child.viewSw = viewSw;

        this.onToggleRuleView(child);
      }
    })
  }
  toggleChildrenImageAnnotation(rule: RevRule, viewSw: boolean) {
    
    let imageChildren: RevRule[] = rule.imageChildren;
    for (let i=0; i<imageChildren.length; i++) {

      let image = imageChildren[i];
      image.viewSw = viewSw;

      this.onToggleRuleView(image);
    }
  }
  onToggleImageAnnotations(viewSw: boolean) {
    this.toggleImageAnnotationsSw = viewSw;
    let elements: RevRule[] = this.displayedRules.filter((r) => r.isImage);
    elements.forEach((r) => {
      if (r.pageNum == this.curPage) {
        r.viewSw = viewSw;
        this.onToggleRuleView(r);
        //this.toggleChildrenAnnotations(r, viewSw);
      }
    });
    this.displayedRules.forEach((r) => {
      if (r.pageNum == this.curPage) {

        // toggle only images
        this.toggleChildrenImageAnnotation(r, viewSw);
      }
    })
  }

  onDocIframeLoaded() {
    this.docFrameLoadedPageNum = this.curPage;  
    
    /* Removed to keep previous toggle choice
        if (
      //this.initAnnotationsloadedPageNum !== this.curPage &&
      this.rulesListLoadedPageNum == this.curPage
    ) {
      
      this.ngRedux.getState().revDocRules.forEach((r) => {
         this.addAllAnnotationsToDoc();
          setTimeout(() => {
            this.toggleFailedAnnotations();
          }, 500);
        })
      }
      */
    

    this.catService.pdfPageLoaded$.next(true);

    // if filter are already active and we switch to new page (nothing to search)
    // need to check if annotations are already displayed
    // one possible call method for hiding annotation and then show it 
    if (this.activeFilters) {
      this.catService.searchFinished$.next(true);
    }

    this.docFrameLoaded = true;
  }
  onNewPageLoaded() {
    this.docFrameLoadedPageNum = this.curPage;
    console.log('frame loaded: ' + this.docFrameLoadedPageNum);


    this.docFrameLoaded = true;
    this.catService.pdfPageLoaded$.next(true);
    if (this.activeFilters) {
      this.catService.searchFinished$.next(true);
    }
    this.revService.pdfAnnotationRenderReady$.next();
  }

  onClaimBoxDraw(box: BoundingBox) {
    const pageNum = this.docViewer.displayedPage - 1;

    this.sharedService.emitPopupchReceivedEvent({
      title: 'translate.rev.claimBlockTitle',
      icon: 'exclamation-triangle',
      subTitle: 'translate.rev.claimBlockConfirm',
      approve: () => this.createClaimBlock(pageNum, box),
      onClose: () => this.docViewer.removeBoundingBoxes(),
    });
  }

  private createClaimBlock(pageNum: number, box: BoundingBox) {
    const doc = this.doc;
    const algRunHeadPayload = {
      doc_id: doc.docId,
      run_type: 'DOC_REV_REVALUATE',
      env_id: this.ngRedux.getState().curEnv.id,
      cat_version_id: doc.catVersionId,
    };

    this.claimBlockSaving = true;
    this.commonService.addAlgRunHead(algRunHeadPayload).pipe(
      switchMap((runNum: number) =>
        this.revService.createClaimBlock(runNum, doc.docId, pageNum, box).pipe(
          switchMap((result: RevClaimBlockResult) => this.awaitClaimBlockReevaluation(runNum, doc.docId, result))
        )
      )
    ).subscribe({
      next: () => {
        this.claimBlockSaving = false;
        this.ngRedux.dispatch({
          type: actionsList.RELOAD_CAT_DOC_PAGE_REQ,
          data: false,
        });
        this.ngRedux.dispatch({
          type: actionsList.REMOVE_CURRENT_ANNOTATIONS
        });
        this.ngRedux.dispatch({
          type: actionsList.GET_REV_DOC_CARDS_START
        });
      },
      error: (err) => {
        this.claimBlockSaving = false;
        console.error('Error creating claim block', err);
        this.sharedService.showInfoMessage({
          messageKey: err instanceof HttpErrorResponse && err.status == 400
            ? 'translate.rev.claimBlockNoPhrases'
            : 'translate.error.rev.claimBlock',
          infoType: 'error'
        });
      },
    });
  }

  private awaitClaimBlockReevaluation(runNum: number, docId: number, result: RevClaimBlockResult): Observable<void> {
    if (!result.reevaluation_initiated) {
      return of(undefined);
    }

    if (this.reevalJobService.isAsyncEnabled()) {
      this.reevalJobService.startJob(runNum, {
        kind: 'REV',
        docId: docId,
        elementId: result.claim_phrase_id,
        isImage: false,
      });
      return of(undefined);
    }

    return this.processStatusPollingService.pollUntilDone(runNum).pipe(map(() => undefined));
  }

  
  addAllAnnotationsToDoc() {
    this.ngRedux.getState().revDocRules.forEach((r) => {
      this.showRuleAnnotation(r, false);
    });
  }

  toggleFailedAnnotations() {
    this.initAnnotationsloadedPageNum = this.curPage;
    this.ngRedux.getState().revDocRules.forEach((r) => {
      r.viewSw = r.revStatusCode == RevStatus.NOT_PASSED;
      this.onToggleRuleView(r, false);
    });
  }

  onToggleSelectAll() {
    this.displayedRules.forEach((p) => {
      p.checkedSw = this.toggleAllSw;
      
      let contentChildren = p.contentChildren;
      contentChildren?.forEach((child) => child.checkedSw = this.toggleAllSw);

      let imageChildren = p.imageChildren;
      imageChildren?.forEach((child) => child.checkedSw = this.toggleAllSw);

      let children = p.children;
      children && Object.keys(children).forEach((key) => {
        children[key]?.forEach((child) => child.checkedSw = this.toggleAllSw)
      })
    });
  }

  downloadAnnotatedDoc() {
    this.downloadingFile = true;
    this.revService.createAnnotateFileReq(this.doc).subscribe(
      (runNum) => {
        this.revService.processAnnotatePrecheck(runNum).subscribe(
          (data) => {},
          (err) => {
            this.downloadFileError(err);
          }
        );

        this.processStatusTimer = setInterval(() => {
          this.authService.getProcessStatus(runNum).subscribe(
            (data) => {
              if (data.status == ProcessRunStatusEnum.FINISHED) {
                clearInterval(this.processStatusTimer);
                this.catService
                  .getS3Objects([data.outDocS3Key], true)
                  .subscribe(
                    async (data2) => {
                      let url = this.catService.getS3TempObjectPresignedUrl(data.outDocS3Key);
                      console.log(url);
                      
                      let blob = await fetch(url).then(r => r.blob());
                      this.downloadingFile = false;
                      
                      var element = document.createElement('a');
                      element.href = URL.createObjectURL(blob);
                      let fileName = this.doc.docName;
                      if (!this.doc.docName.endsWith('.pdf')) {
                        fileName = `${this.doc.docName}.pdf`;
                      }
                      element.download = `${fileName}`;
                      
                      // element.href =
                      //    'https://s3.eu-central-1.amazonaws.com/scai.qa.tmpdocs.com/db4ab5f0-7f19-4940-900d-4db9f3c13838/annotate_precheck/218a8b1c-90ff-11ed-9641-f9f98cb65d8b.pdf';

                      element.setAttribute('target', '_blank');
                      document.body.appendChild(element);
                      element.click();
                      document.body.removeChild(element);
                    },
                    (err) => {
                      this.downloadFileError(err);
                    }
                  );
              } else if (data.status == ProcessRunStatusEnum.FAILED) {
                this.downloadFileError(
                  this.translateService.instant(
                    'translate.cat.annotateProcessFailed'
                  )
                );
              }
            },
            (err) => {
              this.downloadFileError(err);
            }
          );
        }, this.getProcessStatusIntervalSeconds * 1000);
      },
      (err) => {
        this.downloadFileError(err);
      }
    );
  }

  downloadFileError(err) {
    clearInterval(this.processStatusTimer);
    this.downloadingFile = false;
    this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
  }

  onAnnMouseEnter(ann: AnnotationElement) {
    let rule = this.ngRedux
      .getState()
      .revDocRules.find((r) => r.phraseId == ann.annId || r.revRuleId == ann.annId);
    if (rule) this.revRulesList.onMouseEnter(rule);
  }

  onAnnMouseLeave(ann: AnnotationElement) {
    let rule = this.ngRedux
      .getState()
      .revDocRules.find((r) => r.phraseId == ann.annId || r.revRuleId == ann.annId);
    if (rule) this.revRulesList.onMouseLeave(rule);
  }
  findChildrenRule(rule: RevRule, annId: number): RevRule | null {

    let childrenKeys: string[] = Object.keys(rule.children);  
    for (let k=0; k<childrenKeys?.length; k++) {
      
      let key = childrenKeys[k];
      let currChildArr: RevRule[] = rule.children[key];
      for (let i = 0; i < currChildArr.length; i++) {
        let child = currChildArr[i];
        if (child.phraseId == annId || child.revRuleId == annId) {
            
            return child;
        }
      }
    }
    return null;
  }
  findContentChildrenRule(rule: RevRule, annId: number): RevRule | null {

    let contentChildren: RevRule[] = rule.contentChildren;
    for (let i = 0; i < contentChildren?.length; i++) {
      let child = contentChildren[i];
      if (child.phraseId == annId || child.revRuleId == annId) {
          return child;
      }
    }
    return null;

  }
  findImageChildrenRule(rule: RevRule, annId: number): RevRule | null {

    let imageChildren: RevRule[] = rule.imageChildren;
    for (let i = 0; i < imageChildren?.length; i++) {

      let child = imageChildren[i];
      if (child.phraseId == annId || child.revRuleId == annId) {
            return child;
      }
    }
    return null;
  }
  onAnnClicked(ann: AnnotationElement) {

    let revDocRules = this.ngRedux.getState().revDocRules;
    let foundRule = undefined;
    for (let i = 0; i < revDocRules?.length; i++) {
      let r = revDocRules[i];
      if (r.phraseId == ann.annId || r.revRuleId == ann.annId) {
        foundRule = r;
        break;
      }

      foundRule = this.findChildrenRule(r, ann.annId);
      if (foundRule) {
        break;
      }

      foundRule = this.findContentChildrenRule(r, ann.annId);
      if (foundRule) {
        break;
      }
      foundRule = this.findImageChildrenRule(r, ann.annId);
      if (foundRule) {
        break;
      }
    }
    if (foundRule) {
      this.ngRedux.dispatch({
        type: actionsList.REV_RULE_ANN_CLICKED,
        data: foundRule,
      });
    }
  }

  onTypesPanelHide() {
    if (!this.selectedTypeNodes || this.selectedTypeNodes.length == 0) {
      this.filterSubTypes = null;
    } else {
      this.filterSubTypes = this.selectedTypeNodes
        .filter((n) => n.data['treeLevel'] == 1)
        .map((n) => n.key);
    }

    let prevSearchValues =
      this.ngRedux.getState().revRulesSearchParams == null
        ? []
        : this.ngRedux.getState().revRulesSearchParams.subTypeList ?? [];
    let curSearchValues = this.filterSubTypes ?? [];
    if (curSearchValues.join(',') !== prevSearchValues.join(','))
      this.filterRules();
  }

  onPanelResizeStart(event: any) {
    this.panelResizing = true;
  }

  onPanelResizeEnd(event: any) {
    this.panelResizing = false;
  }

  getRevCards() {
    this.getCardsSub?.unsubscribe();
    this.sub?.unsubscribe();

    this.cardsLoading = true;
    this.ngRedux.getState().revDocRules = [];

    this.getCardsSub = this.revService.getRevCards(this.doc.docId).subscribe(
      (searchId) => {
        console.log(searchId);
        this.pullSearchStatus(
          searchId,
          () => {
            this.revService.getRevCardsSearch(searchId).subscribe(
              (data) => {
                this.cardsLoading = false;

                if (
                  this.ngRedux.getState().dlRevDoc &&
                  this.ngRedux.getState().dlRevDoc.cardId
                ) {
                  this.ngRedux.dispatch({
                    type: actionsList.UI__NAVIGATE_TO_TAB,
                    data: this.tabIdList.REV_DOC__CARDS,
                  });
                }
              },
              (err) => {
                this.cardsLoading = false;
              }
            );
          },
          () => {
            this.cardsLoading = false;
            this.sharedService.showInfoMessage({
              messageKey: 'translate.alert.searchError',
              infoType: 'error'}
            );
          }
        );
      },
      (err) => (this.cardsLoading = false)
    );
  }

  pullSearchStatus(searchId: number, onFinished, onError) {
    this.sub?.unsubscribe();
    this.sub = this.authService.getSearchStatus(searchId).subscribe(
      (status) => {
        if (status == SearchRunStatusEnum.FINISHED) {
          onFinished();
        } else if (status == SearchRunStatusEnum.ERROR) {
          onError();
        } else {
          setTimeout(() => {
            this.pullSearchStatus(searchId, onFinished, onError);
          }, this.searchStatusIntervalSec * 1000);
        }
      },
      (err) => {
        onError();
      }
    );
  }

  downloadIndd() {
    this.downloadingZip = true;
    this.catService.getS3Objects([this.doc.inddS3Key]).subscribe(
      () => {
        let url = this.catService.getS3TempObjectPresignedUrl(this.doc.inddS3Key);
        this.tryDownloadFile(url);
      },
      (err) => {
        this.downloadingZip = false;
      }
    );
  }

  tryDownloadFile(url: string) {
    this.sub2?.unsubscribe();
    this.sub2 = this.catService.checkFileExists(url).subscribe(
      (exists) => {
        if (exists) {
          console.log(url);
          var element = document.createElement('a');
          element.href = url;
          element.setAttribute('download', this.doc.fileName);
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          this.downloadingZip = false;
        } else {
          setTimeout(() => {
            this.tryDownloadFile(url);
          }, 100);
        }
      },
      (err) => {
        this.downloadingZip = false;
      }
    );
  }

  onUpdateSpellingWhitelist() {
    this.docSpellcheckWhitelistingOpenSw = false;
    this.ngOnInit();
  }

  onSaveFromPageTool() {
    this.pageToolOpenSw = false;
    this.revRulesList.reloadData();
  }

  onFilterChange(data: {filter: {id: string, key: string}, enabled: boolean}) {

    const enabledFilter = data.enabled;

    if (!enabledFilter) {
      this.ngRedux.dispatch({
        type: actionsList.ADD_REV_IGNORED_STATUS_CODE,
        data: data.filter
      })
    } else {
      this.ngRedux.dispatch({
        type: actionsList.REMOVE_REV_IGNORED_STATUS_CODE,
        data: data.filter
      })

    }
          // set filters

      let mappedRevRuleIgnoredStatusCode = this.revService.mapRevRuleIgnoredStatusCodes();
      if (mappedRevRuleIgnoredStatusCode == "") {

        mappedRevRuleIgnoredStatusCode = null;
      }
      this.revService.setRevIgnoredStatus(this.doc.docId, mappedRevRuleIgnoredStatusCode).subscribe(() => {
      
      });
    // FIRE SEARCH
    let reloadCurrPage = false;
    if (!data.enabled) {

      if (this.filterStatus?.id == data.filter.id) {

        this.filterStatus = null;

      }
        this.ngRedux.getState().revRulesSearchParams = this.getSearchParams();
        // check if any other filter is active
        if (!this.checkIsFiltersActive()) {
          reloadCurrPage = true;
        }

    } 
    //this.resetFilterParams();
    
    this.ngRedux.dispatch({
      type: actionsList.INVALIDATE_PDF_CACHE
    })
    
    if (reloadCurrPage) {
      this.ngRedux.dispatch({
        type: actionsList.SELECT_REV_DOC_PAGE_NUM,
        data: this.curPage,
      });
    } else {
      this.ngRedux.dispatch({
        type: actionsList.RELOAD_CAT_DOC_PAGE_REQ
      })
    }

  }

  handleProcessingDoc() {
    this.handleProcessingDocTimer = setInterval(() => {
      this.authService.getProcessStatus(this.doc.runNum).subscribe(
        (data) => {
          this.doc.processStatus = data;
          this.doc.runStatusCode = data.status as string;
          if (
            data.status == ProcessRunStatusEnum.FINISHED ||
            data.status == ProcessRunStatusEnum.FAILED
          ) {
            this.displayProcessStatus = false;
          }
        },
        (err) => {
          this.getProcStatusFailedCnt++;
          if (this.getProcStatusFailedCnt > 20) {
            clearInterval(this.handleProcessingDocTimer);
          }
        }
      );
    }, this.getProcessStatusIntervalSeconds * 1000);
  }

  openProcessStatus(doc: RevDoc, event: Event) {
    event.stopPropagation();  
    this.displayProcessStatus = true;
  }

  checkProcessStatusAndOpen(revDoc: RevDoc, event: Event) {

    if (revDoc.processStatus) {
      this.openProcessStatus(revDoc, event);
    }
  }
  get lang() {
    return this.ngRedux.getState().ui_lang
  }

}
